import { render, staticRenderFns } from "./fullLogo.vue?vue&type=template&id=a09fb1fe&"
import script from "./fullLogo.vue?vue&type=script&lang=js&"
export * from "./fullLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports